import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonsModule,
  WavesModule,
  CollapseModule,
  TableModule,
  BreadcrumbModule,
  IconsModule,
  ModalModule,
  InputsModule,
  CardsModule,
  SelectModule,
  InputUtilitiesModule,
  SidenavModule,
  TooltipModule,
  PopoverModule,
  AccordionModule,
  CheckboxModule, TabsModule, ToastModule} from 'ng-uikit-pro-standard';
import { SideComponent } from './side/side.component';
import { RouterModule } from '@angular/router';
import { ImageWidthToMediaPipe } from '../image-width-to-media.pipe';
import { HeaderComponent } from './header/header.component';
import { EffectsModule } from '@ngrx/effects';
import { HeaderEffects } from './header.effects';
import { TreasureComponent } from './treasure/treasure.component';

@NgModule({
  declarations: [
    SideComponent,
    ImageWidthToMediaPipe,
    HeaderComponent,
    TreasureComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    WavesModule,
    CollapseModule,
    TableModule,
    ButtonsModule,
    TableModule,
    ButtonsModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    IconsModule,
    ModalModule,
    InputsModule,
    CardsModule,
    InputsModule,
    InputUtilitiesModule,
    SelectModule,
    SidenavModule,
    AccordionModule,
    TooltipModule,
    PopoverModule,
    CheckboxModule,
    TabsModule,
    EffectsModule.forFeature([HeaderEffects]),
  ],
  exports: [
    HeaderComponent,
    SideComponent,
    TreasureComponent,
    ImageWidthToMediaPipe,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    WavesModule,
    CollapseModule,
    TableModule,
    ButtonsModule,
    TableModule,
    ButtonsModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    IconsModule,
    ModalModule,
    InputsModule,
    CardsModule,
    InputsModule,
    InputUtilitiesModule,
    SelectModule,
    SidenavModule,
    AccordionModule,
    TooltipModule,
    PopoverModule,
    CheckboxModule,
    ModalModule,
    ButtonsModule,
    TabsModule,
  ],
  providers: [
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: environment.reCaptchaSiteKey,
    //   } as RecaptchaSettings,
    // },
  ],
})
export class SharedModule { }

// Currently ng-recaptcha is not compatible with Ivy.
